module.exports = __webpack_public_path__ + "img/2400.8ff5ef65.jpg";